export * from './tab3.component'